import { useMemo } from 'react';
import { useNavigate } from 'react-router';
import { JobListingCard } from '@tempmee/react-blocks';
import { JobPostingStatus } from '~/domain/PermanentJobs';
import { useJobProfessionDisplay } from '~/hooks';

import { STATUS_MAP } from './Constants';
import { TJobCardProps } from './Types';

export const JobCard = ({
  candidateCount,
  closedAt,
  id,
  office,
  onsiteInterviewsCount,
  professionType,
  publishedAt,
  status,
  subProfession,
  title,
}: TJobCardProps) => {
  const navigate = useNavigate();

  const dateLabel = useMemo(() => {
    if (status === JobPostingStatus.Closed) {
      return `Closed on ${closedAt}`;
    }

    return `Posted on ${publishedAt}`;
  }, [closedAt, publishedAt, status]);

  const professionTypeDisplay = useJobProfessionDisplay({
    profession: professionType,
    subProfession,
  });

  const isClosed = status === JobPostingStatus.Closed;

  return (
    <JobListingCard
      data-cy="active-job-card"
      status={STATUS_MAP[status]}
      title={title || 'UNTITLED'}
      jobRole={professionTypeDisplay || undefined}
      office={office?.name}
      dateLabel={dateLabel}
      candidates={candidateCount ?? 0}
      // The legacy card surfaced remaining onsite-interview slots as a
      // "N INTERVIEWS LEFT" warning badge (≤3) / error (0). The redesigned block
      // promotes that count to a first-class OPEN INTERVIEWS stat instead.
      openInterviews={isClosed ? '-' : onsiteInterviewsCount ?? 0}
      onCardClick={() => navigate(`/permanent-jobs/job-overview/${id}`)}
    />
  );
};
